import { InvoiceInterface } from 'constants/invoice';
import { useFetch } from 'hooks/useFetch';

export function useInvoiceConditionally() {
  const { data } = useFetch<InvoiceInterface>('invoice/current');
  const { data: invoice, mutate, error, loading } = useFetch<InvoiceInterface>(
    () => (data?.id ? 'invoice/current' : 'invoice/next')
  );

  return {
    invoice,
    mutate,
    error,
    loading
  };
}

export function useInvoiceCustom(type: string) {
  if (type === 'conditionally') {
    return useInvoiceConditionally();
  }

  const { data: invoice, mutate, error, loading } = useFetch<InvoiceInterface>(
    type ? `invoice/${type}` : ''
  );

  return {
    invoice,
    mutate,
    error,
    loading
  };
}

export function useInvoiceCurrent() {
  const { data: invoice, mutate, error, loading } = useFetch<InvoiceInterface>(
    'invoice/current'
  );

  return {
    invoice,
    mutate,
    error,
    loading
  };
}

export function useInvoiceNext() {
  const { data: invoice, mutate, error, loading } = useFetch<InvoiceInterface>(
    'invoice/next'
  );

  return {
    invoice,
    mutate,
    error,
    loading
  };
}

export function useInvoiceConditionallyWithOrientation(
  orientation: string | null
) {
  const { data } = useFetch<InvoiceInterface>('invoice/current');
  const { data: invoice, mutate, error, loading } = useFetch<InvoiceInterface>(
    () => {
      if (!orientation) {
        return data?.id ? 'invoice/current' : 'invoice/next';
      }
      return orientation === 'RIGHT' ? 'invoice/next' : 'invoice/current';
    }
  );

  return {
    invoice,
    mutate,
    error,
    loading
  };
}
